import React from 'react';

const Salutation = ({ formData, handleInputChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="salutation">Anrede</label>
      <select id="salutation" name="salutation" value={formData.salutation} onChange={handleInputChange} required>
        <option value="Mr">Herr</option>
        <option value="Mrs">Frau</option>
        <option value="Other">Andere</option>
      </select>
    </div>
  );
};

export default Salutation;
